
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { AuthDialog } from "@/components/auth/AuthDialog";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useBrand } from "@/contexts/BrandContext";

export default function Login() {
  const navigate = useNavigate();
  const { brand, isWhiteLabel } = useBrand();
  const { session, loading } = useAuth();
  const [isResettingPassword, setIsResettingPassword] = useState(false);
  const [isProcessingReset, setIsProcessingReset] = useState(false);
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");

  useEffect(() => {
    if (!loading && session) navigate("/dashboard", { replace: true });
  }, [loading, navigate, session]);

  // Show loading while checking auth state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-2 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  const handlePasswordReset = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !newPassword) {
      toast.error("Please fill in all fields");
      return;
    }

    setIsProcessingReset(true);
    try {
      const { error } = await supabase.auth.updateUser({
        email: email,
        password: newPassword
      });

      if (error) throw error;

      toast.success("Password updated successfully");
      setIsResettingPassword(false);
      setEmail("");
      setNewPassword("");
      navigate("/dashboard");
    } catch (error) {
      console.error("Password reset error:", error);
      toast.error("Failed to reset password");
    } finally {
      setIsProcessingReset(false);
    }
  };

  return (
    <main className="brand-login-page flex min-h-screen items-center justify-center p-4">
      <div className="w-full max-w-md">
        <AuthDialog
          open
          onOpenChange={() => undefined}
          isResettingPassword={isResettingPassword}
          isProcessingReset={isProcessingReset}
          email={email}
          setEmail={setEmail}
          newPassword={newPassword}
          setNewPassword={setNewPassword}
          onPasswordReset={handlePasswordReset}
          defaultView="sign_in"
          presentation="page"
        />
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="brand-login-back mt-5 w-full text-center text-sm underline-offset-4 hover:underline"
        >
          Back to {isWhiteLabel ? (brand?.config.company_name || "home") : "Snapshot Live"}
        </button>
      </div>
    </main>
  );
}
